import { isMainStatementLine } from '../helpers';

const resolveTransaction = ({ statement, transaction }) => {
    return transaction || statement.Transaction || null;
};

const resolveLineRole = (statement) => {
    if (statement.isCommission) {
        return 'commission';
    }
    if (statement.isClientAdvance) {
        return 'advance';
    }
    return 'main';
};

export const buildCompactStatementRow = ({ statement, transaction, extra = {} }) => {
    const resolvedTransaction = resolveTransaction({ statement, transaction });
    const hasCommission = Boolean(resolvedTransaction?.Statements?.length > 1 && isMainStatementLine(statement));

    return {
        ID: statement.ID,
        key: statement.ID,
        TransactionID: resolvedTransaction?.ID || statement.TransactionID,
        Transaction: resolvedTransaction,
        Project: statement.Project || resolvedTransaction?.Project,
        RefDate: statement.RefDate || resolvedTransaction?.RefDate,
        WorkDate: statement.WorkDate || resolvedTransaction?.WorkDate,
        WorkDateCancelled: statement.WorkDateCancelled || resolvedTransaction?.WorkDateCancelled,
        Currency: statement.Currency || resolvedTransaction?.Currency,
        Amount: statement.Amount,
        Percentage: statement.TransactionPerc,
        PercentageOnGross: statement.TransactionPercOnGross,
        TaxedAmount: statement.TaxedAmount,
        AmountDef: statement.AmountDef,
        TaxedAmountDef: statement.TaxedAmountDef,
        ExchangeRate: statement.ExchangeRate,
        TaxCode: statement.TaxCode,
        TaxAmount: statement.TaxAmount,
        TaxDef: statement.TaxDef,
        TaxCode2: statement.TaxCode2,
        TaxAmount2: statement.TaxAmount2,
        TaxDef2: statement.TaxDef2,
        VatCode: statement.VatCode,
        VatAmount: statement.VatAmount,
        VatDef: statement.VatDef,
        isCommission: statement.isCommission,
        isClientAdvance: statement.isClientAdvance,
        isInvoiced: statement.isInvoiced ?? Boolean(statement.InvoiceID),
        InvoiceID: statement.InvoiceID,
        InvoiceNumber: statement.InvoiceNumber,
        InvoiceDate: statement.InvoiceDate,
        InvoicePosted: statement.InvoicePosted,
        Status: statement.Status,
        PaidStatus: statement.PaidStatus,
        PaidStatusName: statement.PaidStatusName,
        PaymentID: statement.PaymentID,
        PaymentNumber: statement.PaymentNumber,
        PaymentDate: statement.PaymentDate,
        IsInNw3Payment: statement.IsInNw3Payment,
        Nw3PaymentID: statement.Nw3PaymentID,
        IsInNw3PaymentIDs: statement.IsInNw3PaymentIDs,
        Description: statement.Description,
        BillingInfoID: statement.BillingInfoID,
        DepartmentCreated: statement.DepartmentCreated,
        OnHold: statement.OnHold,
        Nw3Locked: statement.Nw3Locked,
        HasCommission: hasCommission,
        LineRole: resolveLineRole(statement),
        originalTransaction: resolvedTransaction,
        ...extra,
    };
};
